import axiosProvider from "../../../utils/axios-provider/axios-provider";

// Actions
export const FETCH_AUTHORIZE_URL_SUCCESS = "merge/FETCH_AUTHORIZE_URL_SUCCESS";
export const FETCH_AUTHORIZE_URL_FAILURE = "merge/FETCH_AUTHORIZE_URL_FAILURE";

// Reducer
const initialState = {
  error: null,
  url: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_AUTHORIZE_URL_SUCCESS:
      return {
        ...state,
        error: null,
        url: action.payload
      };
    case FETCH_AUTHORIZE_URL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
}
export const fetchAuthorizeUrlSuccess = url => ({
  type: FETCH_AUTHORIZE_URL_SUCCESS,
  payload: url
});

export const fetchAuthorizeUrlFailure = error => ({
  type: FETCH_AUTHORIZE_URL_FAILURE,
  payload: error
});

/**
 * Fetches a properly formatted authorize url to trigger source account sign in
 * @param {string} mergePath The mergePath will be used to tell the edge callback endpoint where to callback into
 */
export const fetchAuthorizeUrl = (baseUrl, mergePath) => async dispatch => {
  try {
    const {
      data: { url }
    } = await axiosProvider.getInstance().post(
      `${baseUrl}/merge/authorizeUrl`,
      {
        mergePath
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    dispatch(fetchAuthorizeUrlSuccess(url));
  } catch (error) {
    dispatch(fetchAuthorizeUrlFailure(error));
  }
};

/**
 * The source account cookies are secure cookies, and cannot be killed within the browser. This edge endpoint expires the cookies so that we can clean house after exiting the merge accounts flow.
 */
export const expireSourceAccountCookies = () => async (dispatch, getState) => {
  const {
    paths: { api }
  } = getState();
  try {
    await axiosProvider.getInstance().get(`${api}/merge/expireCookies`);
  } catch (error) {}
};

// Selectors
export const getAuthorizeUrl = state => state.merge.authorize.url;
